import styled, {css} from 'styled-components/native';
import {RFValue} from 'react-native-responsive-fontsize';
import {Platform} from 'react-native';
import FastImage from '../../../../../../Interface/Images/FastImageWithFallback';


export const Container = styled.View`
  border-style: solid;
  border-bottom-width: 1px;
  border-bottom-color: ${({theme}) => theme.colors.border};
  padding-bottom: ${RFValue(12)}px;
  margin-bottom: ${RFValue(12)}px;
`;

export const Header = styled.View`
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
`;

export const ProductValueContainer = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: ${RFValue(8)}px;
  flex: 1;
  min-width: 0;
`;

//@ts-ignore
export const ProductImage = styled(FastImage)`
  width: ${RFValue(45)}px;
  height: ${RFValue(45)}px;
  border: 2px solid ${({theme}) => theme.colors.image_border};
  border-radius: ${RFValue(12)}px;
`;

export const ValueContainer = styled.View`
  flex: 1;
  flex-shrink: 1;
  min-width: 0;
`;

export const Value = styled.Text`
  font-family: ${({theme}) => theme.fonts.bold};
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(16)}px;
  margin-bottom: ${Platform.OS === 'ios' ? RFValue(-4) : RFValue(-8)}px;
`;

export const ValueGroup = styled.View`
  flex-direction: column;
  align-items: flex-start;
  flex-shrink: 1;
  width: 100%;
`;

export const ValueDescription = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.blue};
  font-size: ${RFValue(11)}px;
  flex-shrink: 1;
`;

//@ts-ignore
export const Image = styled(FastImage)`
  width: 100%;
  height: ${RFValue(80)}px;
  border-radius: ${RFValue(12)}px;
`;

export const CurrentLevelContainer = styled.TouchableOpacity`
  flex-direction: row;
  align-items: center;
  gap: ${RFValue(12)}px;
  height: ${RFValue(45)}px;
  border: 1px solid ${({theme}) => theme.colors.blue};
  padding: ${RFValue(6)}px ${RFValue(8)}px;
  border-radius: ${RFValue(12)}px;
  background-color: ${({theme}) => theme.colors.blue_main_opacity};
  margin-top: ${RFValue(6)}px;
  ${({theme}) =>
    Platform.OS === 'ios'
      ? css`
          shadow-color: ${theme.colors.blue};
          shadow-offset: 0px 4px;
          shadow-opacity: 0.15;
          shadow-radius: 4px;
        ` : css`
          elevation: 1;`
      }
`;

export const CurrentCarBadge = styled.View`
  width: ${RFValue(32)}px;
  height: ${RFValue(32)}px;
  border-radius: ${RFValue(24)}px;

  background-color: ${({theme}) => theme.colors.gold_light};
  align-items: center;
  justify-content: center;
  border-width: 2px;
  border-color: ${({theme}) => theme.colors.gold};
`;

export const CurrentLevelInfo = styled.View`
  justify-content: flex-end;
  align-items: flex-end;
`;

export const CurrentLevelName = styled.Text`
  font-family: ${({theme}) => theme.fonts.medium};
  color: ${({theme}) => theme.colors.blue};
  font-size: ${RFValue(9)}px;
  text-align: right;
  line-height: ${RFValue(12)}px;
  padding-top: ${RFValue(1)}px;
`;

export const BaratinhasCount = styled.View`
  flex-direction: row;
  align-items: center;
`;

export const BaratinhasCountLabel = styled.Text`
  font-family: ${({theme}) => theme.fonts.bold};
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(10)}px;
  line-height: ${Platform.OS === 'ios' ? undefined : RFValue(12)}px;
  margin-left: ${RFValue(2)}px;
`;
